export default function changeTitlePage(newTitle) {
	document.title = `${newTitle} - A plataforma que ajuda o pequeno empresário a aparecer na internet.`;
}
